/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, iterChildren, CanBeSignal, getProp, CanBeSignals, $GraphicsBox} from '@gongxigames/framework/core/fragments/BuilderY';
import {cacheAsSprite} from '@gongxigames/framework/core/fragments/display/CacheAsSprite';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {Rectangle, SCALE_MODES} from 'pixi.js';

export type ReplaceProps = CanBeSignals<{
    name: string;
    region: Rectangle;
    immediate?: boolean;
    showOriginal?: CanBeSignal<boolean>;
    debug?: boolean;
    resolution?: number;
    scaleMode?: SCALE_MODES;
}>;

export const $Replace: FC<ReplaceProps> = (props) => {
    const children = [...iterChildren(props.children)];

    if (children.length !== 1) {
        throw new Error('Cache: bitmap can be created from only one root container object');
    }

    const name = getProp(props.name);
    const immediate = getProp(props.immediate);
    const region = getProp(props.region);
    const resolution = getProp(props.resolution);
    const scaleMode = getProp(props.scaleMode);
    const original = children[0];

    cacheAsSprite.add({
        name,
        immediate,
        region,
        resolution,
        scaleMode,
        provider: original,
    });

    const cache = cacheAsSprite.get(name);

    return Store.computed(() => {
        const showOriginal = getProp(props.showOriginal);
        const debug = getProp(props.debug);

        if (debug) {
            return <>
                {original}
                <$GraphicsBox
                    position={region}
                    boxWidth={region.width}
                    boxHeight={region.height}
                    boxColor={0xff00ff}
                    boxAlpha={0.6}
                />
            </>;
        }

        if (showOriginal) {
            return original;
        }

        return cache;
    });
};